import React from 'react'
import { trackEvent } from '../../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../../context/MatchScreenContext'
import { FEEDBACK_DEFAULTS, MODULE_KEYS } from '../../moduleRegistry'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { Heading } from '../HeadingModule/Heading'
import { Subheading } from '../HeadingModule/Subheading'
import '../../styles/ExpandedFeedbackModule/FeedbackInitial.scss'

type Props = {
  onContact: () => void
  onDismiss: () => void
}

/** Landing state: heading/subheading with the external (review) and internal (contact) CTAs. */
export const FeedbackInitial = ({ onContact, onDismiss }: Props) => {
  const { heading, subheading, externalCTA, externalCTALink, internalCTA } = useModuleConfig(
    MODULE_KEYS.feedback,
    FEEDBACK_DEFAULTS
  )
  const { state: { pageKey } } = useMatchScreen()

  const handleExternalClick = () => {
    trackEvent('FeedbackModule', 'External Click', {
      page_key: pageKey,
      link: externalCTALink
    })
    onDismiss()
  }

  return (
    <div className="expanded-feedback-module__initial" data-testid="expanded-feedback-initial">
      <header className="expanded-feedback-module__header">
        <Heading as="h2" id="expanded-feedback-heading" className="expanded-feedback-module__heading" text={heading} />
        <Subheading className="expanded-feedback-module__subheading" text={subheading} />
      </header>
      <div className="expanded-feedback-module__buttons">
        <a
          className="expanded-feedback-module__button expanded-feedback-module__button-cta expanded-feedback-module__button-external"
          href={externalCTALink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleExternalClick}
        >
          {externalCTA}
        </a>
        <button
          type="button"
          className="expanded-feedback-module__button expanded-feedback-module__button-cta expanded-feedback-module__button-internal"
          onClick={onContact}
        >
          {internalCTA}
        </button>
      </div>
    </div>
  )
}
